import { render, staticRenderFns } from "./menuBtn.vue?vue&type=template&id=463c1f94&scoped=true"
import script from "./menuBtn.vue?vue&type=script&lang=js"
export * from "./menuBtn.vue?vue&type=script&lang=js"
import style0 from "./menuBtn.vue?vue&type=style&index=0&id=463c1f94&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463c1f94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('463c1f94')) {
      api.createRecord('463c1f94', component.options)
    } else {
      api.reload('463c1f94', component.options)
    }
    module.hot.accept("./menuBtn.vue?vue&type=template&id=463c1f94&scoped=true", function () {
      api.rerender('463c1f94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/basic/menuBtn/menuBtn.vue"
export default component.exports